import { render } from "./ContentsContainer.vue?vue&type=template&id=7bd8821d&scoped=true"
const script = {}

import "./ContentsContainer.vue?vue&type=style&index=0&id=7bd8821d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd8821d"]])

export default __exports__